// CC: taken from onboarding-wizard.component.ts -> MTA methods (addMta, updateEmailRelayConfig, verifyMta, etc.)
import * as util from 'util';
import {Component, Input} from "@angular/core";
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {GeneralService} from "../../../services/generalService";
import {RouteService} from "../../../services/routeService";
import {NotificationService} from "../../../services/notificationService";
import {DICTIONARY} from "../../../dictionary";

@Component({
	selector: 'onboarding-mta-component',
	templateUrl: './onboarding-outbound-mta.component.html',
})
export class OnboardingOutboundMtaComponent {
	@Input() relay: any;
	@Input() direction: 'outbound' | 'inbound' = 'outbound';

	constructor(public gs: GeneralService, private rs: RouteService, private ns: NotificationService) {}

	dic = DICTIONARY;
	updateMtaInProcess = false;
	domainErr = false;
	showAddForm = false;
	mtaToMove: any;
	mtaInEdit: any;

	// CC: route API call based on direction
	callRelayApi = (data) => {
		if (this.direction === 'inbound') {
			return this.rs.activateInboundEmailRelayAndGenKey(data);
		}
		return this.rs.activateEmailRelayAndGenKey(data);
	}

	// CC: taken from email-relay-integration.component.ts -> resolveDomainHost
	resolveDomainHost = () => {
		if (!this.gs.isValidDomain(this.relay.domain)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.invalidDomain, this.relay.domain));
			this.domainErr = true;
			return;
		}
		this.updateMtaInProcess = true;
		const action = this.direction === 'inbound'
			? this.dic.CONSTANTS.inboundRelayActions.domainMta
			: this.dic.CONSTANTS.erSettingsActions.domainMta;
		const updateData = {
			action,
			domain: this.relay.domain
		};
		this.callRelayApi(updateData).then((response) => {
			this.relay.host = response.exchange;
			this.updateMtaInProcess = false;
		}, () => {
			this.updateMtaInProcess = false;
		});
	}

	// CC: taken from email-relay-integration.component.ts -> addMta
	addMta = () => {
		if (!this.gs.isValidDomain(this.relay.domain)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.invalidDomain, this.relay.domain));
			this.domainErr = true;
			return;
		}
		this.relay.newPort = parseInt(this.relay.newPort);
		const updateData = {
			action: this.dic.CONSTANTS.erSettingsActions.mta,
			type: 'add',
			host: this.relay.host,
			port: this.relay.newPort,
			domain: this.relay.domain
		};
		this.updateMtaInProcess = true;
		this.callRelayApi(updateData).then((response) => {
			this.updateMtaInProcess = false;
			this.relay.mtas = response.mtas;
			this.relay.host = '';
			this.relay.newPort = '';
			this.relay.domain = '';
			this.showAddForm = false;
			this.verifyMta(this.relay.mtas[this.relay.mtas.length - 1]);
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, () => {
			this.updateMtaInProcess = false;
		});
	}

	// CC: taken from email-relay-integration.component.ts -> updateEmailRelayConfig
	updateEmailRelayConfig = (action, type = '', index = null) => {
		this.updateMtaInProcess = true;
		let updateData: any = {action};
		switch (action) {
			case this.dic.CONSTANTS.erSettingsActions.mta:
				if (type === 'move') {
					updateData._id = this.mtaToMove._id;
					updateData.idx = index;
				}
				else if (type === 'edit') {
					updateData._id = this.mtaInEdit._id;
					updateData.host = this.mtaInEdit.host;
					updateData.port = parseInt(this.mtaInEdit.port);
					updateData.domain = this.mtaInEdit.domain;
				}
				else {
					updateData._id = this.relay.mtas[index]._id;
					updateData.domain = this.relay.mtas[index].domain;
				}
				updateData.type = type;
				break;
		}
		this.callRelayApi(updateData).then((response) => {
			this.updateMtaInProcess = false;
			switch (action) {
				case this.dic.CONSTANTS.erSettingsActions.mta:
					for (let idx = 0; idx < response.mtas.length; idx++) {
						if (this.relay.mtas[idx]?.editMode) {
							response.mtas[idx].editMode = true;
							this.mtaInEdit = response.mtas[idx];
						}
					}
					this.relay.mtas = response.mtas;
					if (type === 'move') {
						this.mtaToMove = null;
					}
					else if (type === 'edit') {
						this.verifyMta(this.mtaInEdit);
						this.mtaInEdit.editMode = false;
						this.mtaInEdit = null;
					}
					this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
					break;
			}
		}, () => {
			this.updateMtaInProcess = false;
		});
	}

	confirmDeleteMta = (index) => {
		const mta = this.relay.mtas[index];
		this.gs.showPopup({
			title: 'Delete MTA',
			subTitle: `Are you sure you want to delete ${mta.domain} (${mta.host}:${mta.port})?`,
			body: ['This action cannot be undone.'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.updateEmailRelayConfig(this.dic.CONSTANTS.erSettingsActions.mta, 'delete', index);
			},
		});
	}

	// CC: taken from email-relay-integration.component.ts -> setMTAForEdit
	setMTAForEdit = (mta) => {
		this.relay.mtas.forEach(mtaItem => {
			mtaItem.editMode = false;
		});
		mta.editMode = true;
		this.mtaInEdit = mta;
	}

	// CC: taken from email-relay-integration.component.ts -> verifyMta
	verifyMta = (mtaObj) => {
		if (this.updateMtaInProcess) {
			return;
		}
		this.updateMtaInProcess = true;
		const actionInfo = {
			action: this.dic.CONSTANTS.inboundRelayActions.mta,
			type: 'verify',
			host: mtaObj.host,
			port: mtaObj.port,
		};
		mtaObj.loading = true;
		this.callRelayApi(actionInfo).then((response) => {
			mtaObj.verified = response.meta?.type === 'info';
			mtaObj.loading = false;
			this.updateMtaInProcess = false;
		}, () => {
			this.updateMtaInProcess = false;
			mtaObj.loading = false;
			mtaObj.verified = false;
		});
	}

	// CC: taken from email-relay-integration.component.ts -> onDragStartMta
	onDragStartMta = (mta) => {
		this.mtaToMove = mta;
	}

	// CC: taken from email-relay-integration.component.ts -> onDropMta
	onDropMta = (event: CdkDragDrop<any[]>) => {
		if (!this.mtaToMove) {
			return;
		}
		const prevIndex = this.relay.mtas.findIndex(mtaItem => mtaItem === this.mtaToMove);
		const currIndex = event.currentIndex;
		moveItemInArray(this.relay.mtas, prevIndex, currIndex);
		this.updateEmailRelayConfig(this.dic.CONSTANTS.erSettingsActions.mta, 'move', currIndex);
	}
}
